import "./LabUserEditComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {Field, FieldProps, Formik, FormikProps} from "formik";
import {CommonService} from "../../../../../shared/services";
import Grid from "@mui/material/Grid";
import FormikSelectDropdownComponent
    from "../../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import TableWrapperV2Component
    from "../../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../../constants";
import {ITableColumn} from "../../../../../shared/models/table.model";
import commonService from "../../../../../shared/services/common.service";
import AssignEntityUserLocationComponent
    from "../../../../../shared/components/assign-entity-user-location/AssignEntityUserLocationComponent";
import TooltipComponent from "../../../../../shared/components/tooltip/tooltipComponent";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import {useLocation, useNavigate} from "react-router-dom";
import RouteConfigService from "../../../../../shared/services/route-config.service";
import LinkComponent from "../../../../../shared/components/link/LinkComponent";

interface LabUserEditComponentProps {
    userDetailsList: any;
    labId?: any;
    onUpdateComplete: Function;
    onEditCancel: Function;
}

const labPhysicianDetailsValidationSchema = Yup.object({
    userId: Yup.string()
        .nullable(),
});


interface labPhysicianDetailsFormSchema {
    userId: string;
}

const labInformationInitialValues: labPhysicianDetailsFormSchema = {
    userId: "",
}

const MODULE_NAME = "labUserList";
const modalInitialConfig = {isOpen: false, userId: undefined, locationDetails: []}
const LabUserEditComponent = (props: LabUserEditComponentProps) => {
    const {userDetailsList, labId, onEditCancel} = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [modalConfig, setModalConfig] = useState(modalInitialConfig)

    const [userList, setUserList] = useState<any>([]);
    const [userListDropdown, setUserListDropdown] = useState<any>([]);
    const formikRef = useRef<FormikProps<any>>(null);
    const columns: ITableColumn[] = [
        {
            id: 'id',
            label: 'ID',
            isDefaultColumn: true,
            fixed: 'left',
            width: '150',
            content: (item: any) => (
                <>
                    {item?.userDetails?.id || '-'}
                </>
            )
        },
        {
            id: 'userName',
            label: 'User Name',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {commonService.generateNameFromNameObject(item?.userDetails) || '-'}
                </>
            )
        },
        {
            id: 'gender',
            label: 'Gender',
            isDefaultColumn: false,
            align: 'center',
            content: (item: any) => (
                <>
                    {item?.userDetails?.gender || '-'}
                </>
            )

        },
        {
            id: 'mobileNumber', label: 'Mobile Number', isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                item?.userDetails?.mobileNumber ?
                    <>
                        {CommonService.getMaskedMobileNumber(item?.userDetails?.mobileNumber)}
                    </> : <>-</>
            )
        },
        {
            id: 'emailId',
            label: 'Email ID',
            isDefaultColumn: true,
            align: 'left',
            width: '250',
            content: (item: any) => (
                <>
                    {item?.userDetails?.emailId || '-'}
                </>
            )
        },
        {
            id: 'role',
            label: 'Role',
            isDefaultColumn: true,
            width: '150',
            content: (item: any) => (
                <>
                    {item?.userDetails?.roleObj?.title || '-'}
                </>
            )
        },
        {
            id: 'location',
            label: 'Assigned Location',
            isDefaultColumn: true,
            width: '150',
            content: (item: any) => {
                const locationLists = item?.locationDetails?.map((location: any) => location.name) || [];

                const chips = locationLists.map((locationName: string) => (
                    <ChipComponent key={locationName} label={locationName}/>
                ));

                return (
                    <>
                        {locationLists.length > 0 ? <TooltipComponent arrow={true} placement={"top"} tooltip={chips}>
                            <div
                                className={"ellipses-text"}>{locationLists.map((locationName: string) => locationName).join(",")}</div>
                        </TooltipComponent> : "-"}
                    </>
                );
            }
        },
        {
            id: "assign_location",
            label: 'Assign Location',
            isDefaultColumn: false,
            align: 'center',
            width: '150',
            content: (item: any) => (
                <>
                    <ButtonComponent variant={"text"} color={"primary"}
                                     handleClick={() => {
                                         setModalConfig((prev) => {
                                             return {
                                                 ...prev,
                                                 isOpen: true,
                                                 userId: item?.userDetails?.id,
                                                 locationDetails: item?.locationDetails || []
                                             }
                                         })
                                     }}
                    >
                        Assign Location
                    </ButtonComponent>
                </>
            )
        },
        {
            id: "Remove User",
            label: "Un-link User",
            align: "center",
            fixed: "right",
            width: 150,
            content: (item: any, index: number) => {
                return (
                    userList[index]?.roleObj?.title === "Facility Admin" ?
                        <></> :
                        <ButtonComponent
                            startIcon={<RemoveCircleIcon/>}
                            variant={"outlined"}
                            fullWidth={false}
                            size={'small'}
                            type={'button'}
                            color={"primary"}
                            handleClick={
                                () => {
                                    handleRemoveUser(item?.userDetails)
                                }
                            }

                        >
                            Remove
                        </ButtonComponent>
                )
            }
        }
        // {
        //     id: 'lab',
        //     label: 'Lab',
        //     isDefaultColumn: true,
        //     width: '150',
        //     content: (item: IUser) => (
        //         <>
        //             {item?.lab?.name || '-'}
        //         </>
        //     )
        // },
        // {
        //     id: 'createdAt', label: 'Added On', align: 'center',
        //     isDefaultColumn: false,
        //     content: (item: any) => (
        //         <>
        //             {
        //                 item.createdAt ?
        //                     <>
        //                         {commonService.formatDate(item?.createdAt)}
        //                         &nbsp;|&nbsp;
        //                         {commonService.formatTime(item?.createdAt)} <br/>
        //                     </> : <> - </>
        //             }
        //         </>
        //
        //     )
        // },
        // {
        //     id: 'addedBy', label: 'Added by', isDefaultColumn: false, align: 'center',
        //     content: (item: IUser) => (
        //         <>
        //             {commonService.generateNameFromNameObject(item?.createdByDetails) || '-'}
        //         </>
        //     )
        // },
        // {
        //     id: 'actions',
        //     label: '',
        //     isDefaultColumn: true,
        //     hideInColumnPreferences: true,
        //     align: 'center',
        //     width: "100",
        //     fixed: "right",
        //     content: (item: IUser, index: any) => (
        //         <React.Fragment>
        //             <div className="table-actions" id={`view_patient_` + index}>
        //                 <Link to={CommonService._routeConfig.UserDetailsRoute(item?.id)}>
        //                     <div className="table-action">
        //                         <ChevronRightIcon/>
        //                     </div>
        //                 </Link>
        //             </div>
        //         </React.Fragment>
        //     )
        // },
    ];

    const handleUpdateUserLocation = useCallback((values: any) => {
        if (modalConfig.userId) {
            CommonService._lab.updateLabUserLocation(labId, modalConfig.userId, values).then((res) => {
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                CommonService._alert.showToast("Location updated successfully")
                setModalConfig(modalInitialConfig)
            })
        }
    }, [labId, modalConfig.userId])

    const onHandleNext = useCallback(() => {
        onEditCancel(userList);
    }, [onEditCancel, userList]);
    const getUserListDropdown = useCallback(() => {
        CommonService._lab.getLabUserDetails().then((response) => {
            setUserListDropdown(response.data);
        }).catch((error) => {
            console.error("Unable to get lab user", error)
        })
    }, [])

    const handleAddUser = useCallback((userId: string | number, labId: string | number) => {
        const payload = {
            labId: labId,
            userId: userId
        }
        formikRef?.current?.setSubmitting(true);
        CommonService._lab.addLabUserDetails(payload).then((response) => {
            const selectedUser = userListDropdown.find((user: any) => user?.id?.toString() === userId?.toString());
            if (selectedUser) {
                setUserList((prev: any) => {
                    return [...prev, selectedUser]
                })
                if (formikRef) {
                    formikRef?.current?.setFieldValue("userId", "");
                    formikRef?.current?.setSubmitting(false);
                }
            }
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            });
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while adding user")
        })
    }, [userListDropdown])

    const handleRemoveUser = useCallback((user: any) => {
        const payload = {
            labId: labId,
            userId: user?.id
        }
        CommonService._lab.removeAssignedLabUser(payload).then((response) => {
            const userId = user?.id;
            setUserList((prev: any) => {
                return prev.filter((user: any) => user?.id?.toString() !== userId?.toString());
            })
            getUserListDropdown()
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            });
            CommonService._alert.showToast(response.message || "Removed user successfully", "success")
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while removing user", "error")
        })
    }, [getUserListDropdown, labId])

    const handleRedirectUserModule = useCallback(() => {
        navigate(RouteConfigService.AddUserRoute() + CommonService.setUrlSearchParams({
            returnUrl: location.pathname + location.search,
            permissionType: "labUser",
        }))
    }, [location.pathname, location.search, navigate])

    useEffect(() => {
        setUserList(userDetailsList || []);
    }, [userDetailsList]);

    useEffect(() => {
        getUserListDropdown();
    }, [getUserListDropdown]);

    return (
        <div className={'lab-user-edit-component'}>
            <AssignEntityUserLocationComponent
                isOpen={modalConfig.isOpen}
                entityId={labId}
                entityType={"labId"}
                onUpdate={handleUpdateUserLocation}
                assignedLocation={modalConfig.locationDetails || []}
                onClose={() => setModalConfig(modalInitialConfig)}/>
            <div className={'no-form'}>
                <div className="t-form-controls-wrapper">
                    <>
                        <Formik
                            validationSchema={labPhysicianDetailsValidationSchema}
                            initialValues={labInformationInitialValues}
                            validateOnChange={false}
                            validateOnBlur={true}
                            innerRef={formikRef}
                            enableReinitialize={true}
                            validateOnMount={true}
                            onSubmit={() => {
                            }}
                        >
                            {({isSubmitting, values, isValid, setFieldValue, validateForm, resetForm}) => {
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                useEffect(() => {
                                    validateForm();
                                }, [validateForm, values]);
                                return (
                                    <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Field name={'userId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikSelectDropdownComponent
                                                                label={'User'}
                                                                options={CommonService.getFilteredUsersDropdownList(userList, userListDropdown)}
                                                                placeholder={'Select User'}
                                                                // valueKey={'code'}
                                                                valueKey={'id'}
                                                                // required={true}
                                                                getOptionLabel={(option) => (`${option.firstName} ${option.lastName}`) || ''}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                                <div className="redirect-new-link-wrapper">
                                                    <div>Didn't find user?</div>
                                                    <LinkComponent className={"redirect-link"}
                                                                   onClick={handleRedirectUserModule}>Create
                                                        User</LinkComponent>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <ButtonComponent
                                                    className="mrg-left-20 mrg-top-5"
                                                    disabled={!isValid || isSubmitting || values.userId === ''}
                                                    color={"secondary"}
                                                    variant={"outlined"}
                                                    fullWidth={false}
                                                    size={'large'}
                                                    handleClick={() => {
                                                        labId && handleAddUser(values.userId, labId)
                                                    }}>
                                                    Assign User
                                                </ButtonComponent>
                                            </Grid>
                                        </Grid>
                                    </>
                                )
                            }
                            }
                        </Formik>
                        <div className={'form-sub-title mrg-top-20 mrg-bottom-20'}>Added Users</div>
                        {!userList?.length ?
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FeedbackComponent>
                                        No user have been added.
                                    </FeedbackComponent>
                                </Grid>
                            </Grid> :
                            // <>
                            //     {userList?.map((labUser: any, index: any) => {
                            //             return (
                            //                 <div key={index} className="accordion-layout mrg-bottom-20">
                            //                     <AccordionComponent
                            //                         // disabled={!values.labUserId}
                            //                         isExpanded={userList[index]?.islabUserExpand}
                            //                         title={`${CommonService.capitalizeFirstLetter(labUser.firstName)} ${CommonService.capitalizeFirstLetter(labUser.middleName)} ${CommonService.capitalizeFirstLetter(labUser.lastName)}`}
                            //                         subTitle={`(User ID: ${labUser?.id} | ${userList[index]?.roleObj?.title || ""})`}
                            //                         actions={
                            //                             userList[index]?.roleObj?.title === "Facility Admin" ?
                            //                                 <></> :
                            //                                 <ButtonComponent
                            //                                     startIcon={<RemoveCircleIcon/>}
                            //                                     variant={"outlined"}
                            //                                     fullWidth={false}
                            //                                     size={'small'}
                            //                                     type={'button'}
                            //                                     color={"primary"}
                            //                                     handleClick={
                            //                                         () => {
                            //                                             handleRemoveUser(labUser)
                            //                                         }
                            //                                     }
                            //
                            //                                 >
                            //                                     Remove
                            //                                 </ButtonComponent>}
                            //                     >
                            //                         <div className="labUser-details-section">
                            //                             <UserDetailsComponent user={labUser}/>
                            //                         </div>
                            //                     </AccordionComponent>
                            //                 </div>
                            //             )
                            //         }
                            //     )}
                            // </>
                            <div className="table-list-container">
                                <TableWrapperV2Component
                                    isPaginated={false}
                                    isColumnFilterVisible={false}
                                    columns={columns}
                                    url={APIConfig.GET_LAB_ASSIGNED_USER_LIST.URL(labId)}
                                    method={APIConfig.GET_LAB_ASSIGNED_USER_LIST.METHOD}
                                    // extraPayload={{}}
                                    moduleName={MODULE_NAME}
                                />
                            </div>
                        }
                    </>
                </div>
                <div className='form-action-section-edit'>
                    {/*<ButtonComponent*/}
                    {/*    type="button"*/}
                    {/*    color={"primary"}*/}
                    {/*    variant={"outlined"}*/}
                    {/*    // disabled={formikRef?.current?.isSubmitting}*/}
                    {/*    fullWidth={true}*/}
                    {/*    handleClick={cancel}*/}
                    {/*>*/}
                    {/*    Close*/}
                    {/*</ButtonComponent>*/}
                    <ButtonComponent
                        color={"primary"}
                        type="button"
                        variant={"contained"}
                        className={'width-25'}
                        // disabled={formikRef?.current?.isSubmitting}
                        // fullWidth={true}
                        handleClick={onHandleNext}
                    >
                        Done
                    </ButtonComponent>
                </div>
            </div>
        </div>
    );

};

export default LabUserEditComponent;
